<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="银行卡管理"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <van-pull-refresh v-if="dataList!=null" v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        :immediate-check="ischeck"
        finished-text="没有更多了"
        @load="loadMore"
      >
        <div class="accountListBox">
          <router-link to="/BankAdd" class="addAccountBtn">+ 新增收款账号</router-link>
          <van-radio-group v-model="radio" @change="changeSelect">
            <div @click="edit(item.ReceiptsId)" v-for="(item,index) in dataList" :key="index">
              <div class="accountList">
                <div class="flexbox hd">
                  <div class="flexmid">
                    <div class="tit">银行卡号：{{item.Account}}</div>
                    <div class="van-ellipsis">开户人：{{item.Name}}</div>
                    <div class="van-ellipsis">{{item.BankAreaIdsName+" "+item.SubBankName}}</div>
                  </div>
                  <van-icon name="arrow" color="#777" />
                </div>
                <div class="btm" @click.stop>
                  <div class="btn">
                    <label class="radio grey">
                      <van-radio
                        :name="item.SerialNumber"
                        @click="setDefault(item.IsDefault)"
                        icon-size="16px"
                      >{{item.IsDefault?"默认":"设为默认"}}</van-radio>
                    </label>
                  </div>
                  <div @click="del(item.ReceiptsId)" class="btn grey">删除</div>
                </div>
              </div>
            </div>
            <!--list end-->
          </van-radio-group>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
export default {
  data() {
    return {
      radio: "1",
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: []
    };
  },
  components: {},
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");

    this.init();
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    init() {
      var that = this;
      that.options = {
        type: "GetReceiptsApiModelListSearch",
        pageIndex: 1
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1
      });
      this.getList();
    },
    getList() {
      var that = this;
      that.$store.dispatch(this.options).then(
        res => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          if (res.ReceiptsApiModelList.length <= 0) {
            that.finished = true;
          }
          if (this.options.pageIndex > 1) {
            if (res.ReceiptsApiModelList.length > 0) {
              res.ReceiptsApiModelList.forEach(element => {
                that.dataList.push(element);
              });
            }
          } else {
            that.dataList = res.ReceiptsApiModelList;
            that.dataList.forEach(element => {
              if (element.IsDefault) {
                that.radio = element.SerialNumber;
              }
            });
          }
        },
        error => {}
      );
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    edit(id) {
      console.log("edit");
      this.$router.push("/BankEdit?id=" + id);
    },
    del(id) {
      console.log("del");
      var that = this;
      Dialog.confirm({
        title: "系统提示",
        message: "确定删除此卡号！"
      })
        .then(() => {
          that.$store
            .dispatch({
              type: "DelReceipts",
              ReceiptsId:id
            })
            .then(
              res => {
                Toast(res.Message);
                if (res.IsSuccess) {
                    var _findIndex=this.dataList.findIndex(x=>x.ReceiptsId==id);
                    that.dataList.splice(_findIndex, 1);
                }
              },
              error => {}
            );
        })
        .catch(() => {});
    },
    setDefault(isDefault) {
      //console.log(val);
      var that = this;
      var val = this.radio;
      if (!isDefault) {
        Dialog.confirm({
          title: "系统提示",
          message: "确定设定此卡号为默认！"
        })
          .then(
            () => {
              var findOldItems = this.dataList.filter(x => x.IsDefault == true);
              var findItems = this.dataList.filter(x => x.SerialNumber == val);
              that.$store
                .dispatch({
                  type: "EditDefaultBank"
                })
                .then(
                  res => {
                    Toast(res.Message);
                    if (res.IsSuccess) {
                      findOldItems.forEach(x => {
                        x.IsDefault = false;
                      });
                      findItems[0].IsDefault = true;
                    }
                  },
                  error => {}
                );
              //console.log(findItems);
            },
            () => {
              var findOldItems = this.dataList.filter(x => x.IsDefault == true);
              //console.log(findOldItems);
              this.radio = findOldItems[0].SerialNumber;
            }
          )
          .catch(() => {});
      }
    },
    changeSelect(val) {}
  },
  created() {}
};
</script>

<style scoped>
/**银行卡管理**/
.accountListBox .addAccountBtn {
  display: block;
  margin-top: 8px;
  margin-bottom: 8px;
  background: #fff;
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: orange;
  text-align: center;
  font-size: 16px;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}
.accountList {
  background: #fff;
  margin-bottom: 8px;
  font-size: 13px;
  color: #555;
}
.accountList .hd {
  padding: 10px 15px;
  border-bottom: 1px solid #eee;
}
.accountList .flexmid {
  overflow: hidden;
  margin-right: 15px;
}
.accountList .tit {
  font-size: 15px;
  margin-bottom: 6px;
  color: #333;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.accountList .btm {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
}
.accountList .btm .grey {
  vertical-align: middle;
  color: #999;
}
.accountList .btm .grey input {
  vertical-align: middle;
  margin-right: 4px;
  margin-top: -2px;
}
</style>
